import React from 'react';
import { motion } from 'framer-motion';
import { SproutIcon, LayersIcon, FlowerIcon } from 'lucide-react';
const cards = [{
  icon: SproutIcon,
  title: 'Empieza desde cero',
  desc: 'Conoce los materiales, las herramientas, las formas y las técnicas fundamentales sin necesitar experiencia previa.'
}, {
  icon: LayersIcon,
  title: 'Avanza paso a paso',
  desc: 'Practica cada técnica con explicaciones claras, ejemplos visuales y clases grabadas.'
}, {
  icon: FlowerIcon,
  title: 'Crea proyectos increíbles',
  desc: 'Combina formas, colores y composiciones para crear piezas decorativas llenas de detalles.'
}];
export function DesireSection() {
  return;
}